import cl from 'classnames';
import Button from 'components/Button';
import { Link } from 'gatsby';
import get from 'lodash/get';
import * as React from 'react';
import styled from 'styled-components';
import { fromScreen } from 'utils/media-query/responsive.util';
import { Typography } from '../../../components/DesignSystemV2/Typography';
import { LazyImage } from '../../../components/LazyImage';
import { Pagination } from '../../../components/Pagination';
import { colorsV2 } from '../../../style/colors-v2';

const TeacherCarouselWrapper = styled.div`
  .teacher-name {
    margin-top: 8px;
    margin-bottom: 4px;
  }
  img {
    width: 100%;
    border-radius: 8px;
  }
  button {
    width: 100%;
    height: 48px;
    border-radius: 8px;
    margin-top: 24px;
    &:hover {
      p {
        color: ${colorsV2.primary80} !important;
      }
    }
  }
`;

const TeacherCarousel = ({ activeIndex, data }) => {
  const selectedTeacher = data[activeIndex];

  return (
    <TeacherCarouselWrapper>
      <LazyImage
        handle={selectedTeacher.listingImageHandler}
        alt={selectedTeacher.fullName}
      />
      <Typography variant="semi-bold/20-28" className="teacher-name">
        {selectedTeacher.fullName}
      </Typography>
      <Typography variant="medium/14-20" color={colorsV2.black80}>
        {selectedTeacher.displayNameSubtitle}
      </Typography>

      <HighlightItemList>
        {get(selectedTeacher, 'highlights', []).map(highlight => {
          const { id, title, subText, iconHandler } = highlight;
          return (
            <HighlightItem key={id}>
              <div className="icon">
                <LazyImage handle={iconHandler} alt="icon-highlight" />
              </div>
              <div className="highlight-content">
                <div className="title">
                  <Typography
                    variant="semi-bold/14"
                    color={id === 'linear-badge' && colorsV2.primary100}
                  >
                    {title}
                  </Typography>
                </div>
                <div className="sub-text">
                  <Typography
                    style={{ color: colorsV2.black80 }}
                    variant="regular/14"
                  >
                    {subText}
                  </Typography>
                </div>
              </div>
            </HighlightItem>
          );
        })}
      </HighlightItemList>
      <Link to={selectedTeacher.slug}>
        <Button outline>
          <Typography
            style={{ color: colorsV2.primary100 }}
            variant="semi-bold/14-24"
          >
            Xem thông tin giáo viên
          </Typography>
        </Button>
      </Link>
    </TeacherCarouselWrapper>
  );
};

const HighlightItem = styled.div`
  display: grid;
  grid-template-columns: 24px auto;
  grid-column-gap: 8px;

  .highlight-content {
    display: flex;
    flex-wrap: wrap;
    .title {
      margin-right: 4px;
    }
  }
`;
const HighlightItemList = styled.div`
  margin-top: 14px;
  display: grid;
  gap: 6px;
`;

const TeacherInfoWrapper = styled.div`
  display: grid;
  gap: 24px;
  grid-template-rows: 468px 32px;
  justify-items: center;
  .teacher-list {
    display: grid;
    gap: 24px;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: max-content;
    ${fromScreen(1144)} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    .card {
      width: 150px;
      height: 140px;
      cursor: pointer;
      border-radius: 8px;
      padding: 12px;
      display: grid;
      gap: 4px;
      justify-content: center;
      text-align: center;
      border: 1px solid ${colorsV2.gray20};
      transition: all 0.3s;
      img {
        width: 64px;
        opacity: 0.7;
      }

      &:hover {
        border: 1px solid ${colorsV2.primary100};
        > p {
          color: ${colorsV2.primary100};
        }
        img {
          opacity: 1;
        }
      }

      &.active {
        background: ${colorsV2.primary10};
        border: 1px solid ${colorsV2.primary100};
        > p {
          color: ${colorsV2.primary100};
        }
        img {
          opacity: 1;
        }
      }
    }
  }
  .see-more-teacher {
    cursor: pointer;
    margin-top: 18px;
    display: flex;
    justify-content: center;
    > p {
      position: relative;
      &:after {
        position: absolute;
        bottom: 0px;
        left: 0;
        content: '';
        width: 100%;
        transform: scaleX(0);
        transform-origin: 0% 50%;
        transition: transform 250ms ease-in-out;
        border-bottom: solid 1px ${colorsV2.primary100};
      }

      &:hover:after {
        transform-origin: 0% 50%;
        transform: scaleX(1);
      }
    }
  }
`;

const LIMIT_CARD = 12;

const TeacherInfo = ({ activeIndex, data, setActiveIndex }) => {
  const [page, setPage] = React.useState(0);

  const totalPage = Math.ceil(data.length / 12);
  const rangeTeachers = (page + 1) * LIMIT_CARD;
  const teacherPaged = data.slice(rangeTeachers - 12, rangeTeachers);

  return (
    <TeacherInfoWrapper>
      <div className="teacher-list">
        {teacherPaged.map((teacher, index) => (
          <div
            className={cl('card', {
              active: activeIndex === page * 12 + index
            })}
            key={index}
            onClick={() => setActiveIndex(Number(page * 12 + index))}
          >
            <LazyImage
              handle={teacher.detailImageHandler}
              alt={`${teacher.fullName} avatar`}
            />
            <Typography
              variant="medium/16-24"
              className="teacher-name"
              color={colorsV2.black80}
            >
              {teacher.fullName}
            </Typography>
          </div>
        ))}
      </div>
      <Pagination totalPage={totalPage} onSelect={setPage} activePage={page} />
    </TeacherInfoWrapper>
  );
};
const ContentSection = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 343px auto;
  grid-column-gap: 24px;
`;
const VerticalSeparator = styled.div`
  height: 100%;
  width: 1px;
  background-color: ${colorsV2.gray20};
`;

const TeachersHorizontalCarouselWrapper = styled.div`
  .section-title {
    text-align: center;
    margin-bottom: 40px;
  }
`;
export const TeachersDesktop = props => {
  return (
    <TeachersHorizontalCarouselWrapper>
      <Typography
        variant="bold/24-32"
        tabletVariant="bold/32-40"
        desktopVariant="bold/40-48"
        v3
        className="section-title"
        as="h2"
      >
        Đội ngũ giáo viên
      </Typography>
      <ContentSection>
        <TeacherCarousel {...props} />
        <VerticalSeparator />
        <TeacherInfo {...props} />
      </ContentSection>
    </TeachersHorizontalCarouselWrapper>
  );
};
